import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { Share2, Home, Users, Receipt, ArrowLeftRight, X } from '$lib/icons';
import { Button } from '$lib/components/ui/button';
import { addToast } from '$lib/stores/toastStore.svelte';
import { navigate, route } from '$lib/router';

var root_2 = $.from_html(`<!> Share`, 1);
var root_3 = $.from_html(`<button><!> <span class="hidden sm:inline"> </span></button>`);
var root_4 = $.from_html(`<div class="fixed inset-0 z-50 bg-black/50 flex items-end justify-center sm:items-center sm:p-4" role="dialog" aria-modal="true" aria-labelledby="nav-blocked-title" tabindex="-1"><div role="presentation" class="bg-background w-full sm:max-w-[420px] rounded-t-xl sm:rounded-xl shadow-lg animate-in fade-in slide-in-from-bottom-4 sm:zoom-in-95"><div class="p-6 space-y-3 text-center"><h2 id="nav-blocked-title" class="text-base font-semibold">A participant is required</h2> <p class="text-sm text-muted-foreground">Please add at least one participant before navigating away from this page.</p></div> <div class="p-4 border-t"><!></div></div></div>`);
var root = $.from_html(`<div class="w-full space-y-3"><header class="w-full flex items-center justify-between"><h1 class="text-lg font-bold text-primary break-words min-w-0"> </h1> <div class="flex items-center gap-1 shrink-0"><!> <!></div></header> <nav aria-label="Split navigation" class="flex border-b border-border"><!> <button aria-label="Close split" class="ml-auto flex items-center px-3 py-2 text-muted-foreground hover:text-foreground transition-colors min-h-[44px]"><!></button></nav></div> <!>`, 1);

export default function SplitPageHeader($$anchor, $$props) {
	$.push($$props, true);

	/** Optional guard called before any navigation. Return a warning string to block navigation with an info modal, or null to allow navigation. */
	// Navigation guard state
	let showNavBlocked = $.state(false);

	function handleNavigate(target) {
		if ($$props.navigateGuard) {
			const warning = $$props.navigateGuard();

			if (warning) {
				$.set(showNavBlocked, true);

				return;
			}
		}

		navigate(target);
	}

	const activeTab = $.derived(() => {
		const path = route.pathname;

		if (path.endsWith('/participants')) return 'participants';
		if (path.endsWith('/expenses')) return 'expenses';
		if (path.endsWith('/settlement')) return 'settlement';

		return 'dashboard';
	});

	const tabs = [
		{
			id: 'dashboard',
			label: 'Home',
			icon: Home,
			path: () => `/splits/${$$props.splitId}`
		},

		{
			id: 'participants',
			label: 'Participants',
			icon: Users,
			path: () => `/splits/${$$props.splitId}/participants`
		},

		{
			id: 'expenses',
			label: 'Expenses',
			icon: Receipt,
			path: () => `/splits/${$$props.splitId}/expenses`
		},

		{
			id: 'settlement',
			label: 'Settlement',
			icon: ArrowLeftRight,
			path: () => `/splits/${$$props.splitId}/settlement`
		}
	];

	async function handleShare() {
		if (typeof window === 'undefined') return;

		const url = window.location.href;

		if (!navigator.clipboard) {
			addToast({ type: 'info', message: `Share link: ${url}` });

			return;
		}

		try {
			await navigator.clipboard.writeText(url);
			addToast({ type: 'success', message: 'Link copied!' });
		} catch {
			addToast({ type: 'info', message: `Share link: ${url}` });
		}
	}

	var fragment = root();
	var div = $.first_child(fragment);
	var header = $.child(div);
	var h1 = $.child(header);
	var text = $.child(h1, true);

	$.reset(h1);

	var div_1 = $.sibling(h1, 2);
	var node = $.child(div_1);

	{
		var consequent = ($$anchor) => {
			var fragment_1 = $.comment();
			var node_1 = $.first_child(fragment_1);

			$.snippet(node_1, () => $$props.children);
			$.append($$anchor, fragment_1);
		};

		$.if(node, ($$render) => {
			if ($$props.children) $$render(consequent);
		});
	}

	var node_2 = $.sibling(node, 2);

	Button(node_2, {
		onclick: handleShare,
		variant: 'outline',
		size: 'sm',
		class: 'min-h-[44px]',
		'aria-label': 'Share link',

		children: ($$anchor, $$slotProps) => {
			var fragment_2 = root_2();
			var node_3 = $.first_child(fragment_2);

			Share2(node_3, { class: 'h-4 w-4 mr-1' });
			$.next();
			$.append($$anchor, fragment_2);
		},

		$$slots: { default: true }
	});

	$.reset(div_1);
	$.reset(header);

	var nav = $.sibling(header, 2);
	var node_4 = $.child(nav);

	$.each(node_4, 17, () => tabs, $.index, ($$anchor, tab) => {
		const isActive = $.derived(() => $.get(activeTab) === $.get(tab).id);
		const Icon = $.derived(() => $.get(tab).icon);
		var button = root_3();

		button.__click = () => handleNavigate($.get(tab).path());

		var node_5 = $.child(button);

		$.component(node_5, () => $.get(Icon), ($$anchor, Icon_1) => {
			Icon_1($$anchor, { class: 'h-4 w-4 shrink-0' });
		});

		var span = $.sibling(node_5, 2);
		var text_1 = $.child(span, true);

		$.reset(span);
		$.reset(button);

		$.template_effect(() => {
			$.set_attribute(button, 'aria-current', $.get(isActive) ? 'page' : undefined);
			$.set_attribute(button, 'aria-label', $.get(tab).label);

			$.set_class(button, 1, `flex items-center gap-1.5 px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors min-h-[44px]
          ${$.get(isActive)
				? 'border-b-2 border-primary text-primary -mb-px'
				: 'text-muted-foreground hover:text-foreground'}`);

			$.set_text(text_1, $.get(tab).label);
		});

		$.append($$anchor, button);
	});

	var button_1 = $.sibling(node_4, 2);

	button_1.__click = () => handleNavigate('/');

	var node_6 = $.child(button_1);

	X(node_6, { class: 'h-4 w-4 shrink-0' });
	$.reset(button_1);
	$.reset(nav);
	$.reset(div);

	var node_7 = $.sibling(div, 2);

	{
		var consequent_1 = ($$anchor) => {
			var div_2 = root_4();

			div_2.__click = () => {
				$.set(showNavBlocked, false);
			};

			var div_3 = $.child(div_2);

			div_3.__click = (e) => e.stopPropagation();

			var div_4 = $.sibling($.child(div_3), 2);
			var node_8 = $.child(div_4);

			Button(node_8, {
				onclick: () => {
					$.set(showNavBlocked, false);
				},

				class: 'w-full min-h-[44px]',

				children: ($$anchor, $$slotProps) => {
					$.next();

					var text_2 = $.text('Got it');

					$.append($$anchor, text_2);
				},

				$$slots: { default: true }
			});

			$.reset(div_4);
			$.reset(div_3);
			$.reset(div_2);
			$.append($$anchor, div_2);
		};

		$.if(node_7, ($$render) => {
			if ($.get(showNavBlocked)) $$render(consequent_1);
		});
	}

	$.template_effect(() => $.set_text(text, $$props.splitName));
	$.append($$anchor, fragment);
	$.pop();
}

$.delegate(['click']);
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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